/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type OnboardingSummaryStep_org = {
    readonly id: string;
    readonly primaryOrgCalendar: string;
    readonly domains: ReadonlyArray<string | null> | null;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly eventColoringSettingsErrorable: {
        readonly __typename: "EventColoringSettings";
        readonly eventCategoryColorings: ReadonlyArray<{
            readonly active: boolean;
            readonly eventCategory: string;
            readonly googleColorKey: string | null;
            readonly isUserSet: boolean;
        }> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly primaryTeam: ({
        readonly __typename: "Team";
        readonly teamId: string;
        readonly teamName: string;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly userTeams: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly teamId: string;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly userGoals: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly goalId: string;
                readonly targetUrn: {
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                };
                readonly otherUrns: ReadonlyArray<{
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                }>;
                readonly name: string;
                readonly valueUrn: {
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                };
                readonly isDeleted: boolean;
                readonly options: {
                    readonly syncToGoogle: boolean;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly slackAccountsErrorable: {
        readonly __typename: "SlackAccountList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly slackTeamId: string | null;
            readonly slackUserId: string | null;
            readonly teamDisplayName: string | null;
            readonly needsUpdate: boolean;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly autopilotEventsResponse: {
        readonly __typename: "AutopilotEventsResponse";
        readonly enabledOrganized: ReadonlyArray<{
            readonly annotatedEvent: {
                readonly orgTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly state: {
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    };
                }> | null;
                readonly userTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly states: ReadonlyArray<{
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    }> | null;
                }> | null;
            } | null;
        } | null>;
        readonly enabledAttending: ReadonlyArray<{
            readonly annotatedEvent: {
                readonly orgTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly state: {
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    };
                }> | null;
                readonly userTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly states: ReadonlyArray<{
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    }> | null;
                }> | null;
            } | null;
        } | null>;
        readonly suggestedOrganized: ReadonlyArray<{
            readonly annotatedEvent: {
                readonly orgTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly state: {
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    };
                }> | null;
                readonly userTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly states: ReadonlyArray<{
                        readonly active: boolean;
                        readonly subjectType: SubjectUrnTypeEnum;
                        readonly subjectValue: string;
                    }> | null;
                }> | null;
            } | null;
        } | null>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "OnboardingSummaryStep_org";
};
export type OnboardingSummaryStep_org$data = OnboardingSummaryStep_org;
export type OnboardingSummaryStep_org$key = {
    readonly " $data"?: OnboardingSummaryStep_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingSummaryStep_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v6 = [
        (v0 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v8 = [
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any
    ], v9 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "AnnotatedEvent",
            "kind": "LinkedField",
            "name": "annotatedEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrgTag",
                    "kind": "LinkedField",
                    "name": "orgTags",
                    "plural": true,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v8 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTag",
                    "kind": "LinkedField",
                    "name": "userTags",
                    "plural": true,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "states",
                            "plural": true,
                            "selections": (v8 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "timeZone"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingSummaryStep_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domains",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "eventColoringSettingsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventCategoryColoring",
                                "kind": "LinkedField",
                                "name": "eventCategoryColorings",
                                "plural": true,
                                "selections": [
                                    (v2 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "eventCategory",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "googleColorKey",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isUserSet",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "EventColoringSettings",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v3 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "teamName",
                                "storageKey": null
                            }
                        ],
                        "type": "Team",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v4 /*: any*/),
                            (v5 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v3 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                    }
                ],
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "userGoals",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "goalId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "targetUrn",
                                        "plural": false,
                                        "selections": (v6 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "otherUrns",
                                        "plural": true,
                                        "selections": (v6 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "valueUrn",
                                        "plural": false,
                                        "selections": (v6 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isDeleted",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "GoalOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "syncToGoogle",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "userGoals(first:1000000)"
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "slackAccountsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlackAccount",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slackTeamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "slackUserId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamDisplayName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "needsUpdate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SlackAccountList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v5 /*: any*/),
                            (v4 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "timeZone",
                        "variableName": "timeZone"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autopilotEventsResponse",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "enabledOrganized",
                                "plural": true,
                                "selections": (v9 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "enabledAttending",
                                "plural": true,
                                "selections": (v9 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "suggestedOrganized",
                                "plural": true,
                                "selections": (v9 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "type": "AutopilotEventsResponse",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v5 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '28c5a4fcef2b66924f18ca4e00eccb7d';
export default node;
